module.exports = __webpack_public_path__ + "static/media/documentIcon.b0c584f3.svg";